// hooks
import { Fragment, useEffect, useState } from "react";
import useHttp from "hooks/use-http";

// material styles
import { Grid, Button } from "@mui/material";

// components
import LoadingCM from "components/shared/Loading";
import DrawerCM from "components/shared/Drawer";
import TableCM from "components/shared/Table";
import ProgressBarCM from "components/shared/ProgressBar";
import { StyledLink } from "components/shared/Link";

// helper
import GenerateHeadCell from "helper/generate-head-cell";

// request methods
import { getAllReportCardUserCom } from "api/requests";
// constants
import { useParams } from "react-router-dom";
import PaginationCM from "components/shared/Pagination";
import { PAGINATION_LIMIT } from "constants";
import NotFound from "components/shared/NotFound/NotFound";

// excell scores head cells
const headCells = GenerateHeadCell("user_c_exam_score_list");

export default function DisplayExcellScoresList() {
  const params = useParams();
  const { request, loading, isUploading, setLoading, uploadProgress } =
    useHttp(false);

  // excellScores data state
  const [studentData, setStudentData] = useState({});
  const [excellScoresData, setExcellScoresData] = useState({
    data: [],
    count: 0,
  });
  // page state for pagination
  const [page, setPage] = useState(1);

  // get all items
  const getExcellScoresList = async () => {
    setLoading(true);

    const res = await request({
      url: getAllReportCardUserCom,
      values: {
        skip: (page - 1) * PAGINATION_LIMIT,
        limit: PAGINATION_LIMIT,
        student_id: params.studentId,
      },
    });

    if (res) {
      if (res?.count < 1) {
        return setExcellScoresData({
          count: res?.count,
          data: [{ content: "هیچ اطلاعاتی یافت نشد." }],
        });
      }
      let transformedData = res?.data
        .filter((item) => item?.is_present)
        ?.map((items) => ({
          id: items.id,
          score_date: items?.exam?.comprehensive_exam?.date?.string,
          level: items?.exam?.level ?? "ثبت نشد",
          branch: items?.exam?.branch ?? "ثبت نشد",
          answer_sheet: (
            <>
              <StyledLink
                to={`/comprehensive/reportcard/${items.exam_id}`}
                target="_blank"
              >
                <Button color="success" variant="outlined">
                  مشاهده
                </Button>
              </StyledLink>
            </>
          ),
        }));

      setExcellScoresData({
        data: transformedData,
        count: res?.count,
      });
    }
    setLoading(false);
  };

  useEffect(() => {
    getExcellScoresList();
  }, [page]);

  return (
    <DrawerCM title={" لیست آزمون جامع "} $styledHeader>
      {isUploading ? (
        <ProgressBarCM value={uploadProgress} />
      ) : loading ? (
        <LoadingCM />
      ) : (
        <>
          {excellScoresData.count == 0 ? (
            <NotFound title="اطلاعاتی یافت نشد" />
          ) : (
            <Fragment>
              <Grid
                container
                mt={3}
                sx={{ display: "flex", justifyContent: "center" }}
              >
                <Grid item xs={12} my={2}>
                  <TableCM
                    title=""
                    rows={excellScoresData.data}
                    headCells={headCells}
                    page={page}
                    colspan={excellScoresData.count === 0 ? "8" : ""}
                    fontSize="14px"
                    cellFontSize="14px"
                  />
                </Grid>
                <PaginationCM
                  handleChange={(_, val) => setPage(val)}
                  page={page}
                  count={excellScoresData.count}
                />
              </Grid>
            </Fragment>
          )}
        </>
      )}
    </DrawerCM>
  );
}
